export enum ProductTourStatus {
    SEEN = 'seen',
    COMPLETED = 'completed',
    DISMISSED = 'dismissed',
}
